import { useGooglePlacesContext } from '../context/context';

export function useAutocompleteService(): google.maps.places.AutocompleteService | undefined {
	const googlePlacesContext = useGooglePlacesContext();

	return googlePlacesContext?.autocompleteService;
}
